module.exports = __webpack_public_path__ + "static/media/services2.916b5fc8.png";